import { useRef, useState } from 'react'
import { formatBytes } from '../utils/format'

/** A drop zone that is also a button for the file picker. */
export function FileDrop({ onFile, file, prompt = 'Drop a recording here' }: { onFile: (file: File) => void; file?: File | null; prompt?: string }) {
  const [over, setOver] = useState(false)
  const input = useRef<HTMLInputElement>(null)
  return (
    <div
      className={`dropzone${over ? ' is-over' : ''}`}
      role="button"
      tabIndex={0}
      data-testid="file-drop"
      onClick={() => input.current?.click()}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          input.current?.click()
        }
      }}
      onDragOver={(event) => {
        event.preventDefault()
        setOver(true)
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(event) => {
        event.preventDefault()
        setOver(false)
        const dropped = event.dataTransfer.files[0]
        if (dropped) onFile(dropped)
      }}
    >
      <input
        ref={input}
        type="file"
        accept="audio/*,video/*,.mkv,.m4a,.flac,.opus"
        hidden
        onChange={(event) => {
          const chosen = event.target.files?.[0]
          if (chosen) onFile(chosen)
          event.target.value = ''
        }}
      />
      {file ? (
        <>
          <strong>{file.name}</strong>
          <span className="muted small">{formatBytes(file.size)} · click to choose another</span>
        </>
      ) : (
        <>
          <strong>{prompt}</strong>
          <span className="muted small">or click to choose. Audio or video: mp3, m4a, wav, flac, mp4, mov, mkv, webm.</span>
        </>
      )}
    </div>
  )
}
